import React, { useEffect, useState } from 'react'

import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'

import InstitutionsSelector from '../../../Components/shared/Selectors/Institution/InstitutionsSelector'
import { getUser } from '../../../reducers/UserReducer'
import { getInstitutionSectors } from '../../../utils/api/institution'
import SearchCheckbox from '../../../Components/antd/Selects/SearchCheckbox'

const mapStateToProps = state => ({ t: getTranslate(state.locale), user: getUser(state.getUser) })

const Settings = ({ user, onSectorsChange, t }) => {
  const [institutionId, setInstitutionId] = useState(null)
  const [sectorsByInstitution, setSectorsByInstitution] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (institutionId) {
      setLoading(true)

      getInstitutionSectors(user, { id: institutionId }).then(({ data }) => {
        setSectorsByInstitution(prev => ({ ...prev, [institutionId]: data }))
        setLoading(false)
      })
    }
  }, [user, institutionId])

  const handleInstitutionChange = institutionId => {
    setInstitutionId(institutionId)
    onSectorsChange([])
  }

  return (
    <div className='settings h-100 pd-12'>
      <div className='flex-column w-100'>
        <h4><strong>{t('common.institution')}</strong></h4>
        <InstitutionsSelector
          multiple={false}
          values={[institutionId]}
          onChange={handleInstitutionChange}
        />
      </div>
      {institutionId !== null && (
        <div className='mt-8' style={{ height: 'calc(100% - 70px)' }}>
          <SearchCheckbox
            checkAllOption
            items={sectorsByInstitution[institutionId] ?? []}
            labelKey='name'
            loading={loading}
            tooltipKey='name'
            title={t('common.sectors')}
            valueKey='id'
            style={{ height: '100%', margin: '0px' }}
            onCheck={onSectorsChange}
            onCheckAll={onSectorsChange}
          />
        </div>
      )}
    </div>
  )
}

export default connect(mapStateToProps)(Settings)
